import * as yup from "yup";

/**
 * Yup validation schema for the Forgot Password form.
 *
 * Fields validated:
 * - email: Required. Must be a valid email format.
 *
 * Error messages are localized in German.
 */
const forgotPasswordValidation = yup.object().shape({
  email: yup
    .string()
    .email("Ungültige E-Mail")
    .required("E-Mail ist erforderlich!"),
});

export default forgotPasswordValidation;
